/* eslint-disable */
var loadContext = require('./load-context').loadContext

loadContext(require.context('./src', true, /^((?!-test).)*\.js$/))
